import { mapAdminCityService } from "../_services/mapAdminCity.service";

export const mapAdminCityAction = {
  getAllCountsByMappedCities,
  userMapCityDetails,
};
function getAllCountsByMappedCities(values) {
  return mapAdminCityService.getAllCountsByMappedCities(values);
}
function userMapCityDetails(values) {
  return mapAdminCityService.userMapCityDetails(values);
}
